// extracted by mini-css-extract-plugin
export default {"ribbon":"Ribbon_ribbon__d-5a1","ribbonItem":"Ribbon_ribbonItem__VhS7m","link":"Ribbon_link__t-UFo"};